import { render, staticRenderFns } from "./CulturalCreationDetails.vue?vue&type=template&id=3322c2db&scoped=true"
import script from "./CulturalCreationDetails.vue?vue&type=script&lang=js"
export * from "./CulturalCreationDetails.vue?vue&type=script&lang=js"
import style0 from "./CulturalCreationDetails.vue?vue&type=style&index=0&id=3322c2db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322c2db",
  null
  
)

export default component.exports